export const CyInputEditable = {
  EditButton: "EditButton",
  InputField: "InputField",
  SaveButton: "SaveButton",
} as const;
